import {
  Box,
  Flex, Link, Text,
} from '@chakra-ui/react';
import {
  useDeliveryKPI,
} from '@src/modules/performance/context/reports-api-hooks';
import { CircleIndicator } from '@src/modules/performance/components/indicators';
import { roundKpiValue } from '@src/modules/performance/shared/helpers';
import ReportHeader from './ReportHeader';

const subheader = 'Expenditure, Funding, Cost Efficiency and Valuation';
const informationSource = {
  title: 'Transport Programme Delivery',
  content: [
    {
      title: 'Latest NLTP Approved Funding Spent (%)',
      description:
  <Text fontSize="inherit" mb={2}>
    Percentage spent represents the total of all transport-related activities excluding Emergency Works (NZTA share and local share) to the end of the reported financial year as a proportion of the total 3-year NLTP budget. Road Efficiency Group Te Ringa Maimoa has calculated these results.
  </Text>,
      source: null,
    },
    {
      title: 'Original NLTP Approved Funding Spent (%)',
      description:
  <Text fontSize="inherit" mb={2}>
    Percentage spent represents the total of all transport-related activities excluding Emergency Works (NZTA share and local share) to the end of the reported financial year as a proportion of the original 3-year NLTP budget. Road Efficiency Group Te Ringa Maimoa has calculated these results.
  </Text>,
      source:
  <Text fontSize="inherit" as="span">
    Budget sourced from
    {' '}
    <Link href="https://www.nzta.govt.nz/planning-and-investment/learning-and-resources/transport-data/national-land-transport-programme-funding-data/" isExternal>NZTA Planning and investment, National Land Transport Programme, 2021-24 NLTP, NLTP snapshot and tables.</Link>
    <br />
    Expenditure sourced from
    {' '}
    <Link href="https://www.nzta.govt.nz/planning-and-investment/learning-and-resources/transport-data/data-and-tools/" isExternal>NZTA Data and Tools, major activities expenditure.</Link>
  </Text>,
    },
  ],
};

function TransportProgrammeDeliveryReportHeader({ ...rest }) {
  const { data: deliveryData, isLoadingKpi } = useDeliveryKPI();

  return (
    <ReportHeader
      title="Transport Programme Delivery"
      subtitle={subheader}
      informationSource={informationSource}
      {...rest}
    >
      <Flex align="center">
        <Flex align="center">
          <Box mr={2}>
            <CircleIndicator
              size={60}
              colour={deliveryData?.currentPercentage !== undefined ? 'gray.700' : null}
              value={deliveryData && deliveryData?.currentPercentage !== null ? `${roundKpiValue(deliveryData?.currentPercentage, 5, 1)}%` : null}
              isLoading={isLoadingKpi && !deliveryData}
            />
          </Box>
          <Text
            fontWeight="bold"
            fontSize="sm"
            color="gray"
            lineHeight={1.2}
          >
            Latest
            {' '}
            {deliveryData?.budgetPeriod}
            {' '}
            NLTP
            <br />
            Approved Funding Spent
            <br />
            as at
            {' '}
            {deliveryData?.lockYear}
          </Text>
        </Flex>
        <Flex align="center" ml={6}>
          <Box mr={2}>
            <Text
              fontWeight="normal"
              color="gray.700"
              fontSize="2xl"
            >
              {roundKpiValue(deliveryData?.originalPercentage, 5, 1)}
              %
            </Text>
          </Box>
          <Text fontWeight="bold" color="gray" lineHeight={1.2} fontSize="xs">
            Original
            {' '}
            {deliveryData?.budgetPeriod}
            {' '}
            NLTP
            <br />
            Approved Funding Spent
            <br />
            as at
            {' '}
            {deliveryData?.lockYear}
          </Text>
        </Flex>
      </Flex>
    </ReportHeader>
  );
}

export default TransportProgrammeDeliveryReportHeader;
